import { all, takeLatest, put } from "redux-saga/effects";
import {
  LOGIN,
  LOGOUT,
  CREATE_USER,
  DELETE_USER,
  DETAIL_USER,
  UPDATE_USER,
  USER_LIST,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_BY_ADMIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  VERIFYEMAIL,
  RESEND_VERIFICATION,
} from "../actions/user.actions.types";
import httpClient from "../services/http.client";
import { userslice } from "../slices/user";
import * as Effects from "redux-saga/effects";
import { errorMessage, successMessage } from "../../utilities/notification";
import History from "../services/history";
import { affiliateSlice } from "../slices/affiliate";

const call = Effects.call;

function* login({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "auth/signin",
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: false,
  });

  if (error) {
    if (callback) {
      callback({ success: true, data: result.data });
    }
    errorMessage(error?.message);
  } else {
    successMessage(result.message);
    yield put(userslice.actions.setAuthenticationToken(result.data?.token));
    yield put(userslice.actions.loginAction(result.data?.user));
    History.navigate("/");
  }
}

function* logout() {
  const payload = {
    method: "get",
    url: "auth/signout",
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    // errorMessage(error.message);
  } else {
    successMessage(result.message);
    yield put(userslice.actions.logOutAction());
    yield put(affiliateSlice.actions.removeAffiliate());
    History.navigate("/login");
  }
}

function* getUserList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "auth/list",
  };

  const { error, result } = yield call(httpClient, {
    payload: payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(userslice.actions.setUserList(result.data?.users));
      callback({ success: true, data: result.data });
    }
  }
}
function* createUser({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "auth/signup",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: false,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      // yield Effects.put(userslice.actions.createUser(result.data?.user));
      callback({ success: true, data: result.data });
    }
  }
}

function* detailUser({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `auth/detail/${id}`,
  };
  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(userslice.actions.detailUser(result.data?.user));
      callback({ success: true, data: result.data });
    }
  }
}

function* updateUser({ payload: { id, loggedInUser, data, callback } }) {
  const payload = {
    method: "put",
    url: `auth/update/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    callback({ success: false, data: null });
  } else {
    if (loggedInUser) {
      yield put(userslice.actions.loginAction(result.data?.user));
    }
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* changePassword({ payload: { data, callback } }) {
  const payload = {
    method: "put",
    url: `/auth/change-password`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* changePasswordByAdmin({ payload: { id, data, callback } }) {
  const payload = {
    method: "put",
    url: `auth/change-password-by-admin/${id}`,
    data,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* deleteUser({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `auth/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (error) {
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      yield Effects.put(userslice.actions.deleteUser(id));
      successMessage(result.message);
      callback({ success: true, data: result.data });
    }
  }
}

function* forgotPassword({ payload: { data } }) {
  const payload = {
    data,
    method: "post",
    url: `auth/forgot-password`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: false,
  });

  if (error) {
  } else {
    successMessage(result.message);
  }
}

function* resetPassword({ payload: { data } }) {
  const payload = {
    data,
    method: "post",
    url: `auth/reset-password`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: false,
  });

  if (error) {
    // errorMessage(error.message);
  } else {
    History.navigate("/login");
    successMessage(result.message);
  }
}

function* verifyEmail({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: `auth/email-verification`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: false,
  });

  if (error) {
    // errorMessage(error.message);
    callback({ success: false, data: null, message: error.message });
  } else {
    History.navigate("/login");
    successMessage(result.message);
    // callback({ success: true, data: result.data });
  }
}

function* resendVerification({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "auth/resend-email-verification-token",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: false,
  });

  if (error) {
    callback({ success: false, message: error.message });
  } else {
    successMessage(result.message);
    callback({ success: true });
  }
}

function* User() {
  yield all([
    takeLatest(LOGIN, login),
    takeLatest(LOGOUT, logout),
    takeLatest(USER_LIST, getUserList),
    takeLatest(CREATE_USER, createUser),
    takeLatest(DETAIL_USER, detailUser),
    takeLatest(UPDATE_USER, updateUser),
    takeLatest(DELETE_USER, deleteUser),
    takeLatest(CHANGE_PASSWORD, changePassword),
    takeLatest(CHANGE_PASSWORD_BY_ADMIN, changePasswordByAdmin),
    takeLatest(FORGOT_PASSWORD, forgotPassword),
    takeLatest(RESET_PASSWORD, resetPassword),
    takeLatest(VERIFYEMAIL, verifyEmail),
    takeLatest(RESEND_VERIFICATION, resendVerification),
  ]);
}

export default User;
